import { Typography } from '@material-ui/core'
import SyncAltIcon from '@material-ui/icons/SyncAlt'
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat'

import { getTranslate } from '../../localization'
import useStyles from './styles/index.styles'

type WalletContentStructureProps = {
  title: string
  value: string
  isBilateral?: boolean
  showIcon?: boolean
}

export default function WalletContentStructure({
  title,
  value,
  isBilateral,
  showIcon
}: WalletContentStructureProps) {
  const classes = useStyles()

  return (
    <div className={classes.sectionContent}>
      <Typography variant="body1" className={classes.titleColor}>
        {getTranslate(title)}
      </Typography>
      {showIcon ? (
        <div className={classes.flex}>
          <span className={classes.iconWrapper}>
            {isBilateral ? <SyncAltIcon /> : <TrendingFlatIcon />}
          </span>
          <Typography variant="body1">{getTranslate(value)}</Typography>
        </div>
      ) : (
        <Typography variant="body1">{getTranslate(value)}</Typography>
      )}
    </div>
  )
}
